import { createContext, type ReactNode, useContext } from 'react';
import type { AppNavigation } from '@/lib/app-navigation';
import type { Client, DebtType } from '@/types';

export interface ScopeSelection {
  label: string;
  onSelect: () => void;
}

/** Read-only presentation supplied by an app at Hub composition root; no access or persistence. */
export interface ScopePresentation {
  title: string;
  subtitle: string | null;
  label: string;
  imageUrl: string | null;
  operatorAvatar: boolean;
  selectedClient: Client | null;
  operatorSelected: boolean;
  mineSelected: boolean;
  operatorOption?: ScopeSelection;
  mineOption?: ScopeSelection;
  showDebtTypes: boolean;
  onClientSelect: (client: Client) => void;
  onConfirmScope: (client: Client, debtType: DebtType | null) => void;
}

interface ShellPresentation {
  scope: ScopePresentation | null;
  navigation: AppNavigation | null;
  documentTitle: string | null;
}

const ShellPresentationContext = createContext<ShellPresentation>({ scope: null, navigation: null, documentTitle: null });

export function ShellPresentationProvider({ value, children }: { value: ShellPresentation; children: ReactNode }) {
  return <ShellPresentationContext.Provider value={value}>{children}</ShellPresentationContext.Provider>;
}

export function useShellPresentation() {
  return useContext(ShellPresentationContext);
}
